var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeak = function SvgLeak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 197v180c0 8.28-6.72 15-15 15s-15-6.72-15-15v-15H286c-3.98 0-7.79-1.58-10.61-4.39L241 323.21V347c0 8.28-6.72 15-15 15H30v15c0 8.28-6.72 15-15 15s-15-6.72-15-15V197c0-8.28 6.72-15 15-15s15 6.72 15 15v15h151v-90h-15c-8.28 0-15-6.72-15-15s6.72-15 15-15h180c8.28 0 15 6.72 15 15s-6.72 15-15 15h-15v90h151v-15c0-8.28 6.72-15 15-15s15 6.72 15 15M331 62V15c0-8.28-6.72-15-15-15H196c-8.28 0-15 6.72-15 15v47z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268.99 399.5a15 15 0 0 0-25.98 0l-26 45.02A45 45 0 0 0 211 467c0 24.81 20.19 45 45 45s45-20.19 45-45c0-7.9-2.08-15.67-6.01-22.48z"
  })));
};
export default SvgLeak;